import { Injectable } from "@angular/core";
import { SortDirection } from "@angular/material/sort";

export interface StatementsListState {
    pageIndex: number;
    pageSize: number;
    sortActive: string;
    sortDirection: SortDirection;
}

@Injectable({
    providedIn: 'root'
})
export class StatementsState {
    private state: StatementsListState | null = null;

    saveState(state: StatementsListState): void {
        this.state = { ...state };
    }

    getState(): StatementsListState | null {
        const currentState = this.state;
        return currentState ? { ...currentState } : null;
    }

    resetState(): void {
        this.state = null;
    }
}